export interface StatItem {
  value: string;
  label: string;
}

export interface TeamMember {
  name: string;
  role: string;
  bio: string;
  avatar: string;
}

export interface HonorItem {
  year: string;
  title: string;
  issuer: string;
}

export const companyStats: StatItem[] = [
  { value: "18", label: "年行业深耕" },
  { value: "300+", label: "完成作品" },
  { value: "60+", label: "行业奖项" },
  { value: "200+", label: "专业团队成员" },
];

export const companyIntro: string[] = [
  "芒果传媒成立于 2008 年，是一家专注于影视内容制作与传媒服务的综合型内容机构。公司以「用影像记录时代，用内容连接人心」为使命，业务涵盖影视制作、节目策划与内容发行三大板块。",
  "十八年来，芒果传媒始终坚持内容为本、品质优先，累计完成三百余部影视与节目作品，服务众多平台、品牌与机构客户，作品多次获得行业奖项与市场认可。",
  "我们相信，好的内容源于对生活的观察与真诚的表达。未来，芒果传媒将继续深耕现实题材，拥抱技术革新，与更多伙伴一起，共同推动中国影视传媒行业向前发展。",
];

export const companyValues = [
  { icon: "ri-compass-3-line", title: "内容为本", desc: "尊重创作规律，把内容质量作为一切工作的起点。" },
  { icon: "ri-lightbulb-line", title: "创新驱动", desc: "持续探索题材与形式，让作品保持鲜活的生命力。" },
  { icon: "ri-hand-heart-line", title: "真诚合作", desc: "与客户、伙伴与创作者建立长期信任的共赢关系。" },
  { icon: "ri-award-line", title: "匠心品质", desc: "在每一个环节精益求精，交付经得起时间检验的作品。" },
];

export const teamMembers: TeamMember[] = [
  {
    name: "陆铭远",
    role: "创始人 / 董事长",
    bio: "资深影视制片人，深耕行业二十余年，主导出品多部口碑与市场双丰收的代表作品。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20middle%20aged%20asian%20man%20in%20a%20dark%20suit%2C%20warm%20studio%20lighting%2C%20neutral%20background%2C%20corporate%20photography%2C%20no%20text&width=600&height=750&seq=mango-team-01&orientation=portrait",
  },
  {
    name: "林承宇",
    role: "首席内容官 / 导演",
    bio: "知名导演、编剧，擅长现实题材创作，作品多次入围国内外影视评选。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20thoughtful%20asian%20man%20with%20glasses%2C%20warm%20studio%20lighting%2C%20neutral%20background%2C%20corporate%20photography%2C%20no%20text&width=600&height=750&seq=mango-team-02&orientation=portrait",
  },
  {
    name: "苏晚",
    role: "影视制作中心总监",
    bio: "资深制片人，拥有丰富的项目管理经验，负责公司剧集与网络电影的制作统筹。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20poised%20asian%20woman%20in%20business%20attire%2C%20warm%20studio%20lighting%2C%20neutral%20background%2C%20corporate%20photography%2C%20no%20text&width=600&height=750&seq=mango-team-03&orientation=portrait",
  },
  {
    name: "沈弋",
    role: "节目中心总监",
    bio: "综艺节目制作人，主导研发多档现象级节目模式，擅长现场内容与舞台呈现。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20creative%20asian%20woman%20smiling%20warmly%2C%20warm%20studio%20lighting%2C%20neutral%20background%2C%20corporate%20photography%2C%20no%20text&width=600&height=750&seq=mango-team-04&orientation=portrait",
  },
];

export const honors: HonorItem[] = [
  { year: "2025", title: "年度最具影响力内容制作机构", issuer: "影视行业年度评选" },
  { year: "2025", title: "年度优秀剧集制作奖", issuer: "中国影视制作协会" },
  { year: "2024", title: "最佳综艺节目制作团队", issuer: "传媒内容创新大会" },
  { year: "2024", title: "广告影片金奖", issuer: "华语广告影像节" },
  { year: "2023", title: "年度纪录片特别推荐奖", issuer: "国际纪录片展映单元" },
  { year: "2023", title: "优秀内容发行机构", issuer: "新媒体版权交易大会" },
];

export const milestones = [
  { year: "2008", title: "芒果传媒成立", desc: "以影视制作起家，组建第一支专业制作团队。" },
  { year: "2013", title: "拓展节目业务", desc: "成立节目中心，进入综艺与纪实内容领域。" },
  { year: "2018", title: "布局内容发行", desc: "建立发行团队，内容覆盖国内外主流平台。" },
  { year: "2023", title: "数字化升级", desc: "推进虚拟制作与数字化制作基地建设。" },
  { year: "2025", title: "迈向国际化", desc: "多部作品出海展映，开启全球化合作新阶段。" },
];